import React, { useEffect, useRef, useState } from "react";
import InputField from "@/components/InputField";

import CheckboxField from "@/components/CheckboxField";
import { Modal, Button } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { useGeneralApiCall } from "@/services/useGeneralApiCall";
import Loading from "@/components/Loading";
import { showToast } from "@/api/notification";
// import MultipleDropDwornTemp from "@/components/MultipleDropDwornTemp";
// import MulipleDropDownforMSR from "@/components/MulipleDropDownforMSR";
// import AddPhotoModal from "@/components/AddPhotoModal";

import TagsInput from "../components/TagsInputs";
import SelectApparelCategory from "@/components/SelectApparelCategory";

// import {
//   closestCenter,
//   DndContext,
//   MouseSensor,
//   TouchSensor,
//   useSensor,
//   useSensors,
// } from "@dnd-kit/core";
// import {
//   arrayMove,
//   horizontalListSortingStrategy,
//   SortableContext,
//   useSortable,
// } from "@dnd-kit/sortable";
// import { CSS } from "@dnd-kit/utilities";

interface StylePhoto {
  url: string;
  thumbnail: string;
  image_id: string;
}
// interface Category {
//   category_id?: string;
//   cat_id?: string;
//   name: string;
//   parent_category?: string;
//   slug?: any;
//   cover_image?: File | string | null;
//   is_active: boolean;
// }

// interface MSRCatecory {
//   msr_season_year_id?: string;
//   name: string;
//   parent_category?: string;
//   slug?: any;
//   cover_image?: File | string | null;
//   is_active: boolean;
// }

interface tages {
  tag_id: string;
  name: string;
}
interface StyleData {
  msr_season_year_id?: string;
  style_id?: string;
  style_slug?: string;
  category_id?: string;
  msr_category_id?: string;
  apparel_category_id?: string;
  style_name?: string;
  status?: string;
  cover_slugcover_image_id?: string;
  apparel_category?: { name: string } | null;
  msr_category?: { name: string } | null;
  cover_photo?: string | null;
  photos?: StylePhoto[];
  is_active?: boolean;
  show_on_site?: boolean;
  is_msr?: boolean;
  apparel_parent_category?: string;
  tags?: tages[];
}

const StyleDetailForm: React.FC = () => {
  const { getApi, putApi, postApi, deleteApi, loading } = useGeneralApiCall();
  const [tags, setTags] = useState<string[]>([]);
  const [style, setStyle] = useState<any>(null);
  const [isEditing, setIsEditing] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [photoToDelete, setPhotoToDelete] = useState<string | null>(null);
  const [isCoverDelete, setIsCoverDelete] = useState<any>(false);
  const [isStyleDelete, setIsStyleDelete] = useState<any>(false);
  const [error, setError] = useState<string>("");
  const coverPhotoInputRef = useRef<HTMLInputElement>(null);

  const navigate = useNavigate();
  const [showCategory, setshowCategory] = useState(false);

  // const [Categories, setCategories] = useState<any[]>([]);
  // const [MSRCategory, setMSRCategories] = useState<any[]>([]);

  // const [showAddPhotoModal, setShowAddPhotoModal] = useState(false);
  const [showPhotoUploadModal, setShowPhotoUploadModal] = useState(false);
  const [selectedPhotos, setSelectedPhotos] = useState<File[]>([]);
  const [photoPreviews, setPhotoPreviews] = useState<string[]>([]);
  const photoInputRef = useRef<HTMLInputElement>(null);

  const handleOpenPhotoModal = () => {
    setSelectedPhotos([]);
    setPhotoPreviews([]);
    setShowPhotoUploadModal(true);
  };

  // const sensors = useSensors(
  //   useSensor(MouseSensor, { activationConstraint: { distance: 5 } }),
  //   useSensor(TouchSensor)
  // );

  // const [photos, setPhotos] = useState<StylePhoto[]>([]);

  // useEffect(() => {
  //   if (style?.photos) setPhotos(style.photos);
  // }, [style?.photos]);

  // const handlePhotoOrderChange = async (newPhotos: StylePhoto[]) => {
  //   setPhotos(newPhotos);
  //   // API call to update photo order
  // };

  const handlePhotoInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files || []);
    setSelectedPhotos(files);
    setPhotoPreviews(files.map((file) => URL.createObjectURL(file)));
  };

  const handleRemovePreview = (idx: number) => {
    const newFiles = selectedPhotos.filter((_, i) => i !== idx);
    const newPreviews = photoPreviews.filter((_, i) => i !== idx);
    setSelectedPhotos(newFiles);
    setPhotoPreviews(newPreviews);
  };

  const handleUploadPhotos = async () => {
    if (!selectedPhotos.length) {
      showToast({
        message: "Please select at least one photo.",
        type: "warning",
      });
      return;
    }
    const formData = new FormData();
    selectedPhotos.forEach((file) => formData.append("photos", file));
    try {
      const response = await postApi(
        `/api/style/v1/style/update/${style.style_id}/photos/`,
        formData
      );
      if (!response.error_status) {
        showToast({
          message: "Photos uploaded successfully!",
          type: "success",
        });
        setShowPhotoUploadModal(false);
        fetchStyleDetails();
      } else {
        showToast({ message: "Failed to upload photos.", type: "error" });
      }
    } catch (err) {
      showToast({ message: "Error uploading photos.", type: "error" });
    }
  };
  const [state, setstate] = useState(false);

  const { style_id } = useParams();

  const fetchStyleDetails = async () => {
    try {
      const response = await getApi(`api/style/v1/style-details/${style_id}/`);
      if (!response.error_status && response.data) {
        const data: StyleData = response.data;

        setStyle({
          ...data,
          apparel_category: data.apparel_category ?? "",
          msr_category: data.msr_category ?? { name: "" },
          apparel_category_id: data.apparel_category_id || "",
          msr_season_year_id: data.msr_category_id || "",
          cover_photo: data.cover_photo,
          photos: data.photos || [],
          is_active: data.is_active ?? false,
          show_on_site: data.show_on_site ?? false,
          slug: data.style_slug,
          cover_slugcover_image_id: data.cover_slugcover_image_id,
          apparel_parent_category: data.apparel_parent_category,
          tags: data.tags || [],
        });

        // Extract tag names from style.tags and set them for TagsInput
        if (data.tags && Array.isArray(data.tags)) {
          const tagNames = data.tags.map((tag: tages) => tag.tag_id);
          setTags(tagNames);
        }
      } else {
        setError("Failed to load style details. Please try again later");
      }
    } catch (err: any) {
      const message =
        err?.response?.data?.error || err?.message || "Something went wrong";
      navigate(-1);
      showToast({ message, type: "error" });
    }
  };

  console.log(style, "style", tags, "jai maa kali");

  // useEffect(() => {
  //   getApi<{ data: Category[] }>("api/cat/v1/nested-category/").then(
  //     (res: any) => {
  //       setCategories(res?.data || []);
  //     }
  //   );
  // }, []);

  // useEffect(() => {
  //   getApi<{ data: MSRCatecory[] }>(
  //     "/api/msr/v1/msr/msr_season_year_wise_list/"
  //   ).then((res: any) => {
  //     setMSRCategories(res.data.results || []);
  //   });
  // }, []);

  useEffect(() => {
    if (!style_id) return;
    fetchStyleDetails();
  }, [style_id]);

  const handleInputChange = (e: any) => {
    const { name, value, type, checked } = e.target;
    if (!style) return;
    setStyle((prev: any) => ({
      ...prev!,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const toggleEditing = () => setIsEditing((prev) => !prev);

  const handleCoverPhotoChange = async (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = e.target.files?.[0];
    if (!file || !style) return;

    const formData = new FormData();
    formData.append("cover_photo", file);
    try {
      const response = await postApi(
        `/api/style/v1/style/update/${style.style_id}/cover-image/`,
        // style.cover_slugcover_image_id,
        formData
      );
      if (!response.error_status) {
        showToast({ message: "Cover photo updated.", type: "success" });
        fetchStyleDetails();
      } else {
        showToast({ message: "Failed to update cover photo", type: "error" });
      }
    } catch (err) {
      showToast({ message: "Error updating cover photo.", type: "error" });
    }
  };

  // const handlePhotoChange = async (index: number, file: File) => {
  //   if (!style) return;
  //   const imageId = style.photos[index].image_id;
  //   const formData = new FormData();
  //   formData.append("photo", file);
  //   try {
  //     const response = await putApi(
  //       `/api/style/v1/update-photo`,
  //       imageId,
  //       formData
  //     );
  //     if (!response.error_status) {
  //       showToast({ message: "Photo updated.", type: "success" });
  //       fetchStyleDetails();
  //     } else {
  //       showToast({ message: "Failed to update photo", type: "error" });
  //     }
  //   } catch (err) {
  //     showToast({ message: "Error updating photo.", type: "error" });
  //   }
  // };

  const handleDelete = async () => {
    if (!style) return;
    try {
      if (isCoverDelete) {
        const response = await deleteApi(
          `api/style/v1/style-cover-photo-delete`,
          isCoverDelete
        );
        if (response.error_status) {
          showToast({ message: "Failed to delete cover photo", type: "error" });
          return;
        } else {
          showToast({
            message: "Cover photo deleted successfully",
            type: "success",
          });
          fetchStyleDetails();
        }

        setStyle((prev: any) => ({ ...prev!, cover_photo: null }));
        showToast({
          message: "Cover photo deleted successfully",
          type: "success",
        });
      } else if (photoToDelete) {
        const response = await deleteApi(
          `api/style/v1/style/update/${style.style_id}/photos`,
          photoToDelete
        );

        if (!response.error_status) {
          setStyle((prev: any) => ({
            ...prev!,
            photos: prev!.photos.filter(
              (photo: any) => photo.url !== photoToDelete
            ),
          }));

          fetchStyleDetails();

          showToast({ message: "Photo deleted successfully", type: "success" });
        } else {
          showToast({ message: "Failed to delete photo", type: "error" });
        }
      } else if (isStyleDelete) {
        const res = await deleteApi(
          `api/style/v1/style-soft-delete`,
          style.style_slug
        );
        if (!res.error_status) {
          showToast({ message: "Style deleted successfully", type: "success" });
          navigate("/style-management");
        } else {
          showToast({ message: "Failed to delete style", type: "error" });
        }
      }
    } catch (error) {
      showToast({
        message: "An error occurred while deleting the photo",
        type: "error",
      });
    } finally {
      setShowDeleteModal(false);
      setPhotoToDelete(null);
      setIsCoverDelete(false);
      setIsStyleDelete(false);
    }
  };

  // const makeCoverImage = async (image_id: string) => {
  //   try {
  //     const response = await putApi(
  //       `api/style/v1/style-photo/make-cover`,
  //       image_id
  //     );
  //     if (response?.data) {
  //       showToast({
  //         message: "This image has been set as the cover photo.",
  //         type: "success",
  //       });
  //       fetchStyleDetails();
  //     } else {
  //       showToast({ message: "Failed to update cover image", type: "error" });
  //     }
  //   } catch (err: any) {
  //     const error =
  //       err.response?.data?.message || err.message || "Something went wrong";
  //     showToast({ message: error, type: "error" });
  //   } finally {
  //     // loading(false);
  //   }
  // };

  const triggerCoverUpload = () => {
    coverPhotoInputRef.current?.click();
  };

  // const triggerPhotoUpload = (index: number) => {
  //   photoInputRefs.current[index]?.click();
  // };
  const ApprealSeletion = (e: any) => {
    setStyle((s: any) => ({ ...s, apparel_category_id: e }));
    setStyle((s: any) => ({ ...s, msr_season_year_id: "" }));
    setstate(!state);
  };
  // const MSRSeletion = (e: any) => {
  //   setStyle((s: any) => ({ ...s, msr_season_year_id: e }));
  //   setStyle((s: any) => ({ ...s, apparel_category_id: "" }));
  //   setstate(!state);
  // };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (style.apparel_category_id === "" && style.msr_category_id === "") {
      showToast({ message: "Please select a category", type: "warning" });
      return;
    }
    //  else if (itChildArray) {
    //   showToast({ message: "Please select a Child catrgoty", type: "warning" });
    //   return;
    // }

    try {
      const updatedData = {
        name: style.style_name,
        is_approved: style.status,
        // is_active: style.is_active,
        show_on_site: style.show_on_site,
        apparel_category: style.apparel_category_id,
        msr_category: style.msr_season_year_id,
        tags: tags,
      };

      const response = await putApi(
        `api/style/v1/style/update`,
        style.style_id,
        updatedData
      );
      if (!response.error_status) {
        showToast({
          message: response.message || "Style updated successfully!",
          type: "success",
        });
        setIsEditing(false);
        fetchStyleDetails();
      } else {
        showToast({
          message: response.message || "Update failed.",
          type: "error",
        });
      }
    } catch (error: any) {
      showToast({
        message: error.message || "An unexpected error occurred.",
        type: "error",
      });
    }
  };

  // const SortablePhoto = ({
  //   photo,
  //   index,
  //   onDelete,
  // }: {
  //   photo: StylePhoto;
  //   index: number;
  //   onDelete: () => void;
  // }) => {
  //   const { attributes, listeners, setNodeRef, transform, transition } =
  //     useSortable({ id: photo.image_id });
  //   const style = {
  //     transform: CSS.Transform.toString(transform),
  //     transition,
  //     width: 180,
  //     height: 180,
  //     borderRadius: 8,
  //     overflow: "hidden",
  //     border: "1px solid #eee",
  //     position: "relative" as const,
  //     marginRight: 16,
  //     marginBottom: 16,
  //     background: "#fff",
  //     display: "inline-block",
  //   };
  //   return (
  //     <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
  //       <img
  //         src={photo.url}
  //         alt={`Photo ${index + 1}`}
  //         className="preview-image-detail"
  //         style={{ width: "100%", height: "100%", objectFit: "cover" }}
  //       />
  //       {isEditing && (
  //         <button
  //           type="button"
  //           className="btn btn-sm btn-danger position-absolute"
  //           style={{ top: 8, right: 8, zIndex: 2 }}
  //           onClick={onDelete}
  //         >
  //           🗑
  //         </button>
  //       )}
  //     </div>
  //   );
  // };

  if (loading) return <Loading />;
  if (error) return <div className="alert alert-danger mt-4">{error}</div>;
  if (!style) return null;

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className="p-4 mx-auto bg-white shadow rounded mt-5">
          <h1 className="fs-2 fw-bold mb-4">
            {isEditing ? "Edit Style Details" : style.style_name}
          </h1>
          <form onSubmit={handleSubmit}>
            <div className="flex gap-4 w-full justify-around mb-[1rem]">
              <div className="w-3/5 border-1 h-max border-gray-300 rounded mt-[2.5rem] px-4 py-8">
                <InputField
                  label="Name"
                  name="style_name"
                  value={style.style_name}
                  onChange={handleInputChange}
                  disabled={!isEditing}
                />
                {/* <SelectField
                  label="Status"
                  name="status"
                  value={style.status}
                  options={["approved", "pending", "rejected"]}
                  onChange={handleInputChange}
                  disabled={!isEditing}
                /> */}
                <div className="flex gap-2">
                  <h2>Category:</h2>
                  <p>{style.apparel_category}</p>
                </div>

                {isEditing && (
                  <>
                    <TagsInput selectedTags={tags} setSelectedTags={setTags} />
                    <Button
                      className="p-1 mb-2"
                      onClick={() => {
                        setshowCategory(!showCategory);
                      }}
                    >
                      {showCategory && isEditing ? "Hide" : "Show"} Category
                    </Button>
                  </>
                )}

                <br />
                {showCategory && isEditing ? (
                  // <>
                  //   <MultipleDropDwornTemp
                  //     data={Categories}
                  //     setCategoryId={ApprealSeletion}
                  //     parentCategory={style.apparel_category_id}
                  //     isEdit={true}
                  //   />

                  //   <MulipleDropDownforMSR
                  //     data={MSRCategory}
                  //     setCategoryId={MSRSeletion}
                  //     parentCategory={style.msr_category_id}
                  //     isEdit={true}
                  //   />
                  // </>
                  <SelectApparelCategory
                    categoryId={style.apparel_category_id}
                    setCategoryId={ApprealSeletion}
                    addCategory={true}
                  />
                ) : null}
                {/* <CheckboxField
                  label="Active"
                  name="is_active"
                  checked={style.is_active ?? false}
                  onChange={handleInputChange}
                  disabled={!isEditing}
                /> */}
                <CheckboxField
                  label="Show on site"
                  name="show_on_site"
                  checked={style.show_on_site ?? false}
                  onChange={handleInputChange}
                  disabled={!isEditing}
                />

                {/* Buttons */}
                <div className="mt-5 flex flex-wrap gap-2">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={toggleEditing}
                  >
                    {isEditing ? "Cancel" : "Edit"}
                  </button>
                  {isEditing && (
                    <button type="submit" className="btn btn-success">
                      Save Changes
                    </button>
                  )}
                  {isEditing && (
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={handleOpenPhotoModal}
                    >
                      Add New Photo
                    </button>
                  )}
                  {isEditing && (
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={() => {
                        setShowDeleteModal(true);
                        setIsStyleDelete(true);
                      }}
                    >
                      Delete Style
                    </button>
                  )}
                </div>
              </div>

              {/* New Photo Upload Modal */}
              <Modal
                size="xl"
                show={showPhotoUploadModal}
                onHide={() => setShowPhotoUploadModal(false)}
                backdrop="static"
                keyboard={false}
              >
                <Modal.Header closeButton>
                  <Modal.Title>Upload Style Photos</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <input
                    type="file"
                    accept="image/*"
                    multiple
                    ref={photoInputRef}
                    style={{ display: "none" }}
                    onChange={handlePhotoInputChange}
                  />
                  <button
                    type="button"
                    className="btn btn-outline-primary mb-3"
                    onClick={() => photoInputRef.current?.click()}
                  >
                    Upload More Pictures
                  </button>
                  <div className="d-flex flex-wrap gap-3">
                    {photoPreviews.map((src, idx) => (
                      <div key={idx} className="position-relative">
                        <img
                          src={src}
                          alt={`preview-${idx}`}
                          style={{
                            width: "400px",
                            height: "700px",
                            objectFit: "cover",
                            borderRadius: 8,
                            border: "1px solid #eee",
                          }}
                        />
                        <button
                          type="button"
                          className="btn btn-sm btn-danger position-absolute"
                          style={{ top: 2, right: 2 }}
                          onClick={() => handleRemovePreview(idx)}
                        >
                          &times;
                        </button>
                      </div>
                    ))}
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    variant="secondary"
                    onClick={() => setShowPhotoUploadModal(false)}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="primary"
                    onClick={handleUploadPhotos}
                    disabled={!selectedPhotos.length}
                  >
                    Upload
                  </Button>
                </Modal.Footer>
              </Modal>

              {/* Cover Photo */}
              <div className="mb-3">
                <div className="flex justify-between">
                  <label className="form-label fw-semibold">Cover Photo</label>
                  {isEditing && (
                    <>
                      <span
                        className="underline cursor-pointer text-sm mr-4"
                        onClick={triggerCoverUpload}
                      >
                        Change Cover Photo
                      </span>
                      <input
                        type="file"
                        accept="image/*"
                        ref={coverPhotoInputRef}
                        className="d-none"
                        onChange={handleCoverPhotoChange}
                      />
                    </>
                  )}
                </div>
                <div className="d-flex flex-wrap items-center justify-center">
                  {style.cover_photo ? (
                    <div className="position-relative d-inline-block me-3">
                      <img
                        src={style.cover_photo}
                        alt="Cover"
                        className="preview-image"
                        style={{
                          width: "400px",
                        }}
                      />
                      <p className="mt-2 text-success fw-bold text-center">
                        ✅ This is the current cover image
                      </p>
                      {/* {isEditing && (
                        <div>
                          <button
                            type="button"
                            className="btn btn-sm btn-secondary position-absolute"
                            style={{ top: "1rem", right: "3.5rem" }}
                            onClick={triggerCoverUpload}
                          >
                            ✎
                          </button>
                          <button
                            type="button"
                            className="btn btn-sm btn-danger position-absolute"
                            style={{ top: "1rem", right: "1rem" }}
                            onClick={() => {
                              setIsCoverDelete(style.cover_photo_id);
                              setShowDeleteModal(true);
                            }}
                          >
                            🗑
                          </button>
                          <input
                            type="file"
                            accept="image/*"
                            ref={coverPhotoInputRef}
                            className="d-none"
                            onChange={handleCoverPhotoChange}
                          />
                        </div>
                      )} */}
                    </div>
                  ) : (
                    <div className="text-center mx-auto h-full">
                      <p>{`No cover photo available.`}</p>
                      <p>{`=> Contact Developers`}</p>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Photos */}
            <div className="mb-3">
              <div
                role="alert"
                className="fade text-center alert alert-primary show text-4xl font-semibold"
              >
                STYLE PHOTOS
              </div>

              <div className="d-flex flex-wrap row-gap-5">
                {style.photos.map((photo: any, index: any) => (
                  <div
                    key={index}
                    className="position-relative d-inline-block me-3 mb-3 preview-item p-2"
                  >
                    <img
                      src={photo.url}
                      alt={`Photo ${index + 1}`}
                      className="preview-image-detail"
                      // style={{ width: "400px", height: "698px" }}
                    />
                    {isEditing && (
                      <div className="d-flex justify-content-center w-full mx-auto">
                        {/* <button
                          type="button"
                          className="btn btn-sm btn-secondary position-absolute"
                          style={{ top: "1rem", right: "3.5rem" }}
                          onClick={() => triggerPhotoUpload(index)} // Pass image_id here
                        >
                          ✎
                        </button> */}
                        <button
                          type="button"
                          className="btn btn-sm btn-danger position-absolute"
                          style={{ top: "1rem", right: "1rem" }}
                          onClick={() => {
                            setPhotoToDelete(photo.image_id);
                            setIsCoverDelete(false);
                            setShowDeleteModal(true);
                          }}
                        >
                          🗑
                        </button>
                        {/* <input
                          type="file"
                          accept="image/*"
                          className="d-none"
                          ref={(el: HTMLInputElement | null) => {
                            photoInputRefs.current[index] = el!;
                          }}
                          onChange={(e) =>
                            e.target.files &&
                            handlePhotoChange(index, e.target.files[0])
                          }
                        /> */}
                        {/* <button
                          className="btn btn-outline-primary mt-4"
                          // style={{
                          //   bottom: "-4rem",
                          //   transform: "translateX(50%)",
                          // }}
                          // onClick={() => makeCoverImage(photo.image_id)}
                        >
                          Make as Cover Image
                        </button> */}
                      </div>
                    )}
                  </div>
                ))}
              </div>

              {/* <DndContext
                sensors={sensors}
                collisionDetection={closestCenter}
                onDragEnd={(event) => {
                  const { active, over } = event;
                  if (active.id !== over?.id) {
                    const oldIndex = photos.findIndex(
                      (p) => p.image_id === active.id
                    );
                    const newIndex = photos.findIndex(
                      (p) => p.image_id === over?.id
                    );
                    if (oldIndex !== -1 && newIndex !== -1) {
                      const newPhotos = arrayMove(photos, oldIndex, newIndex);
                      handlePhotoOrderChange(newPhotos);
                    }
                  }
                }}
              >
                <SortableContext
                  items={photos.map((p) => p.image_id)}
                  strategy={horizontalListSortingStrategy}
                >
                  <div className="d-flex flex-wrap row-gap-5">
                    {photos.map((photo, index) => (
                      <SortablePhoto
                        key={photo.image_id}
                        photo={photo}
                        index={index}
                        onDelete={() => {
                          setPhotoToDelete(photo.image_id);
                          setIsCoverDelete(false);
                          setShowDeleteModal(true);
                        }}
                      />
                    ))}
                  </div>
                </SortableContext>
              </DndContext> */}
            </div>
          </form>

          {/* Delete Modal */}
          <Modal
            show={showDeleteModal}
            onHide={() => setShowDeleteModal(false)}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header closeButton>
              <Modal.Title>Confirm Delete</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              Are you sure you want to delete this{" "}
              {isCoverDelete
                ? "cover photo"
                : isStyleDelete
                ? "style"
                : "photo"}
              ?
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => {
                  setShowDeleteModal(false);
                  setIsCoverDelete(false);
                  setIsStyleDelete(false);
                  setPhotoToDelete(null);
                }}
              >
                Cancel
              </Button>
              <Button variant="danger" onClick={handleDelete}>
                Delete
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      )}
    </>
  );
};

export default StyleDetailForm;
